// extracted by mini-css-extract-plugin
module.exports = {"batch-claims-page":"BatchClaimUpload_batch-claims-page__28aKE","header-title":"BatchClaimUpload_header-title__3ytzj","help-center-box":"BatchClaimUpload_help-center-box__3Pvxl"};